import { componentFactory } from 'vue-tsx-support';

import { JtnUiRecordAuthors, JtnUiRecordOpinionAuthors } from '@jtn-ui/components/record';
import { ObserverVisibility, tsStoreMixin } from '@jtnews/shared';
import { ImageSourceVM, ImageVM } from '@jtnews/shared/images';

type Author = {
  id: string;
  url?: string;
  name: string;
  targetUrl?: string;
  jobPosition: string;
  image?: {
    fileName: string;
    width: number;
    height: number;
    img: ImageVM;
    sources: ImageSourceVM[];
  };
};

type ComponentData = {
  authorBlockVisibility: ObserverVisibility;
};

export default componentFactory.mixin(tsStoreMixin).create({
  name: 'AuthorBlock',
  props: {
    items: {
      type: Array as () => Author[],
      default: () => [] as Author[]
    },
    isOpinion: {
      type: Boolean,
      default: false
    }
  },
  data(): ComponentData {
    return {
      authorBlockVisibility: new ObserverVisibility('all')
    };
  },
  mounted() {
    this.authorBlockVisibility.event.subscribe(state => {
      if (state.value) {
        const valueName = 'Просмотр';
        const goalName = 'ViewAuthor';
        this.sendNewReachGoal(valueName, goalName);
      }
    });
  },
  methods: {
    sendNewReachGoal(valueName: string, goalName: string) {
      const blockType = 'Центральная колонка';
      const fieldType = 'Блок Автор';
      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName
      });
    },
    sendAuthorClickedRG(authorName: string) {
      const valueName = 'Переход на автора';
      const goalName = 'ClickAuthor';

      this.sendNewReachGoal(valueName, goalName);
      this.sendNewFormatReachGoal('ClickArticleFooter', 'Автор', 'Клик', authorName);
    },
    sendNewFormatReachGoal(
      goalName: string,
      blockType: string,
      actionType: string,
      prop1?: string,
      prop2?: string
    ) {
      this.store.analyticsModule.sendNewFormatReachGoal({
        goalName,
        blockType,
        actionType,
        prop1,
        prop2
      });
    }
  },
  render() {
    return (
      <div>
        {this.isOpinion ? (
          <JtnUiRecordOpinionAuthors
            v-observe-visibility={this.authorBlockVisibility.getOptions('all')}
            authors={this.items}
            onClickedAuthor={({ name }) => this.sendAuthorClickedRG(name)}
          />
        ) : (
          <JtnUiRecordAuthors
            v-observe-visibility={this.authorBlockVisibility.getOptions('all')}
            authors={this.items}
            onClickedAuthor={({ name }) => this.sendAuthorClickedRG(name)}
          />
        )}
      </div>
    );
  }
});
